module.exports = __webpack_public_path__ + "static/img/pay_success.5a3eab6b.png";